// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"speciesCard_wrapper__dbL3w","content":"speciesCard_content__FPBiw","title":"speciesCard_title__XW4HT","description":"speciesCard_description__LK4rw"};